import { loadScriptOnIntent } from '../../../scripts/utils/intent-loader';

class VisionTestModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.iframe = null;
    this.iframeLoaded = false;
  }

  connectedCallback() {
    this.overlay = this.querySelector('.vision-test-modal__overlay');
    this.panel = this.querySelector('.vision-test-modal__panel');
    this.closeButton = this.querySelector('.vision-test-modal__close');
    this.iframeContainer = this.querySelector('.vision-test-modal__iframe-container');

    this.setupEventListeners();
    this.initializeTriggers();
  }

  setupEventListeners() {
    this.closeButton?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  initializeTriggers() {
    const triggers = document.querySelectorAll('[data-vision-test-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  async open() {
    if (!this.iframeLoaded) {
      await this.loadIframe();
    }

    this.isOpen = true;
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    sessionStorage.setItem('vision_test_interaction', 'true');
  }

  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async loadIframe() {
    const iframeUrl = window.theme.settings.visionTestUrl || 'https://luxreaders-visiontest.netlify.app/da';

    this.iframe = document.createElement('iframe');
    this.iframe.src = iframeUrl;
    this.iframe.className = 'vision-test-modal__iframe';
    this.iframe.title = window.theme.strings.vision_test.iframe_title;
    this.iframe.setAttribute('frameborder', '0');
    this.iframe.setAttribute('allowfullscreen', 'true');

    this.iframeContainer.innerHTML = `<div class="vision-test-modal__loading">${window.theme.strings.vision_test.loading}</div>`;
    this.iframeContainer.appendChild(this.iframe);

    this.iframe.addEventListener('load', () => {
      this.iframeContainer.querySelector('.vision-test-modal__loading')?.remove();
    });

    this.iframeLoaded = true;
  }
}

customElements.define('vision-test-modal', VisionTestModal);
